import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { fetchSubscriptions } from '../api/authApi';
import { DataTable } from './DataTable';
import { LoadingSkeleton } from './LoadingSkeleton';
import { StatusBadge } from './StatusBadge';

export function SubscriptionsTable({ customerId, tenantId, emptyMessage }) {
  const navigate = useNavigate();
  const { t } = useTranslation(['billing', 'common', 'statuses']);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = {};
    if (customerId) params.customer_id = customerId;
    if (tenantId) params.tenant_id = tenantId;
    fetchSubscriptions(params)
      .then((r) => setItems(r.data || []))
      .finally(() => setLoading(false));
  }, [customerId, tenantId]);

  const columns = useMemo(() => [
    {
      id: 'plan',
      label: t('billing:plan'),
      render: (s) => s.plan?.name || '—',
    },
    {
      id: 'status',
      label: t('common:status'),
      render: (s) => <StatusBadge status={s.status} category="subscription" size="Sm" />,
    },
    {
      id: 'access',
      label: t('billing:access'),
      render: (s) => (s.accessible ? t('statuses:yes') : t('statuses:no')),
    },
    {
      id: 'period_end',
      label: t('billing:period_end'),
      render: (s) => (
        s.current_period_end
          ? new Date(s.current_period_end).toLocaleDateString()
          : '—'
      ),
    },
  ], [t]);

  if (loading) {
    return <LoadingSkeleton type="Table" rows={3} columns={4} />;
  }

  return (
    <DataTable
      type="Default"
      embedded
      columns={columns}
      rows={items}
      emptyMessage={emptyMessage}
      onRowClick={() => navigate('/subscriptions')}
    />
  );
}
